<fgb-page-header [pageTitle]="'wallet.page.title'" [backButtonLink]="'/'" [showQr]="false" [showFooter]="false"></fgb-page-header>

<div class="container">
  <div class="d-flex page-padding">
    <div class="back-button"></div>
    <!-- Image -->
    <div class="border rounded-4 overflow-hidden p-0">
      <img
        [ngClass]="{
          'image-opacity':
            (currentCampaign.voucherUsesAvailable == 0 && currentCampaign.campaignRedemptions_Quantity == 0) ||
            (currentCampaign.voucherUsesAvailable >= 1 &&
              currentCampaign.voucherRedemptions != currentCampaign.voucherUsesAvailable),
        }"
        alt=""
        [src]="currentCampaign?.image_URL"
        class="logo rounded-4"
      />
    </div>
    <div class="icon-placement">
      <ng-container *ngIf="currentCampaign.campaignRedemptions_Quantity == 0 && currentCampaign.voucherUsesAvailable == 0">
        <span class="icon material-icons text-grey text-end fw-bold ms-3"> lock </span>
      </ng-container>
      <ng-container *ngIf="currentCampaign.voucherUsesAvailable >= 1">
        <span class="icon material-icons text-success text-end fw-bold ms-3"> check_circle </span>
      </ng-container>
    </div>
  </div>
  <!-- Name -->
  <div class="text-white text-center font-size-14 fw-bold mt-3">{{ currentCampaign?.CampaignName }}</div>
  <!-- Expiry -->
  <ng-container *ngIf="!isUsedCampaign">
    <div class="font-size-12 text-white text-center pt-lg-2 pt-0">
      {{ 'offer.expiry' | translate }} {{ currentCampaign.Campaign_ExpiryDate | UtcToLocaltimePipe: dateOption.NgbDateFormat }}
    </div>
  </ng-container>
  <ng-container *ngIf="currentCampaign?.campaignRedemptions_Quantity > 0">
    <div class="available-offer-scan bg-white mt-3 rounded-4 d-flex align-items-center justify-content-center mb-4 mb-lg-2">
      <span class="font-size-12">{{ 'offer.scan.member.barcode' | translate }}</span>
    </div>
  </ng-container>
  <!-- Description -->
  <ng-container *ngIf="currentCampaign?.campaignRedemptions_Quantity == 0">
    <hr class="border-top border-disabled my-3" />
  </ng-container>
  <label class="text-white accordion-label pt-2">{{ 'offer.description' | translate }}</label>
  <div class="text-white font-size-14">{{ currentCampaign?.PortalDescription }}</div>
</div>
